import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { color } from '../../../app/theme';
import {
  BirthdayType,
  CustomerConditionType,
  GenderType,
} from '../../../app/types';
import { setNodeData } from '../../../features/mainSlice';
import Dropdown from '../../shared/Dropdown';

const useStyles = makeStyles(
  {
    root: {
      marginBottom: 36,
    },
    title: {
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: 15,
      lineHeight: '15px',
      color: color.$3,
      marginBottom: 12,
    },
  },
  {
    name: 'TriggerType',
  },
);

const Type = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { selectedNode } = useSelector(state => state.ma);
  const { triggerType } = selectedNode?.data;

  const typeItem = Object.values(CustomerConditionType).map(type => ({
    text: t(`customerConditionNode.${type}`),
    value: type,
  }));

  const onChange = value => {
    let triggerCondition;

    switch (value) {
      case CustomerConditionType.TAG:
        triggerCondition = [{}];
        break;
      case CustomerConditionType.BIRTHDAY:
        triggerCondition = BirthdayType.DAY;
        break;
      case CustomerConditionType.GENDER:
        triggerCondition = GenderType.MALE;
        break;
      case CustomerConditionType.LOCATION:
        triggerCondition = [];
        break;
      default:
        break;
    }

    dispatch(setNodeData({ triggerType: value, triggerCondition }));
  };

  return (
    <div className={classes.root}>
      <div className={classes.title}>{t('condition-setting.type')}</div>
      <Dropdown menuItems={typeItem} value={triggerType} onChange={onChange} />
    </div>
  );
};

export default Type;
